import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { AlertService } from 'src/app/services/alert.service';
import { TouchSequence } from 'selenium-webdriver';
import { UserService } from 'src/app/services/user.service';


@Component({
    templateUrl: 'sign-up-company-info.component.html',
    styleUrls: ['./sign-up-company-info.component.scss']
})

export class SignUpCompanyInfoComponent implements OnInit {
    model: any = {};
    loading = false;
    returnUrl: string;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private authenticationService: AuthenticationService,
        private alertService: AlertService,
        public userService: UserService
    ) { }

    ngOnInit() {
       
    }

    login() {
        this.loading = true;
        console.log(this.model);
        this.authenticationService.login(this.model.email, this.model.password)
            .subscribe(
                data => {
                    // login successful if there's a jwt token in the response
                    if (data && data['token']) {
                        console.log(data);
                        // store user details and jwt token in local storage to keep user logged in between page refreshes
                        localStorage.setItem('currentUser', JSON.stringify(data));
                        this.userService.currentUser = data;
                    }
                    this.router.navigate([this.returnUrl]);
                },
                error => {
                    this.alertService.error(error);
                    this.loading = false;
                });
    }
}
